export default __webpack_public_path__ + "static/media/Gilroy-Light.9df2f5db.woff";